import React, { ChangeEvent, CSSProperties } from 'react';

export interface Props {
  rows?: number;
  onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: () => void;
  onFocus?: () => void;
  placeholder?: string;
  className?: string;
  style?: CSSProperties;
  // eslint-disable-next-line @typescript-eslint/ban-types
  containerStyle?: object;
  disabled?: boolean;
  autoComplete?: string;
  showValidationError?: boolean;
  validationErrorText?: string;
  onRef?: () => void;
  onKeyPress?: () => void;
  value: string;
}

function TextArea({
  rows = 2,
  onBlur = () => {},
  onFocus = () => {},
  onRef = () => {},
  onKeyPress = () => {},
  placeholder = '',
  className = '',
  autoComplete = '',
  style = {},
  containerStyle = {},
  disabled = false,
  showValidationError = false,
  validationErrorText = '',
  value,
  onChange,
}: Props) {
  return (
    <div className={`${className}`} style={containerStyle}>
      <textarea
        rows={rows}
        ref={onRef}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        onKeyPress={onKeyPress}
        className={
          showValidationError
            ? 'form-control form__input-error'
            : 'form-control'
        }
        style={style}
        autoComplete={autoComplete}
        placeholder={placeholder}
        disabled={disabled}
        value={value}
      />
      {showValidationError && (
        <div className="form__input-error-text">{validationErrorText}</div>
      )}
    </div>
  );
}

export default TextArea;
